import {
  getCourseList,
  getCourseDetail,
  getCourseOutline,
  getMyCourses,
  getSkillCategories,
  createOrder,
  getExamList,
  getExamDetail,
  applyExam,
  getMyExamApplications,
  getExamApplicationDetail,
  downloadExamTicket,
  queryExamTicket,
  getTalentList,
  getTalentDetail,
  submitTalentApplication,
  getMyTalentProfile,
  updateTalentProfile,
  getJobList,
  getJobDetail,
  applyJob,
  getMyJobApplications,
  initApp,
  getTypeList,
  getTalentCategories,
  getMessages,
  markMessageRead,
  markAllMessagesRead,
  getHelpTypes,
  getHelpCategories,
  getHelpDetail,
  getBannerList,
  getNoticeList,
  getNoticeDetail,
  getPaymentStatus,
  getQuestionPapers,
  getQuestionList,
  submitQuestionAnswers,
  submitQuestionPaper,
  getQuizList,
  getQuizDetail,
  getMajorList
} from './index'

// 课程相关API
export const courseAPI = {
  // 获取课程列表
  getCourses: async (params = {}) => {
    try {
      const response = await getCourseList(params)
      return response.data || response
    } catch (error) {
      console.error('获取课程列表失败:', error)
      throw error
    }
  },

  // 获取课程详情
  getCourseDetail: async (id) => {
    try {
      const response = await getCourseDetail(id)
      return response.data || response
    } catch (error) {
      console.error('获取课程详情失败:', error)
      throw error
    }
  },

  // 获取课程大纲
  getCourseOutline: async (id) => {
    try {
      const response = await getCourseOutline(id)
      return response.data || response
    } catch (error) {
      console.error('获取课程大纲失败:', error)
      throw error
    }
  },

  // 获取我的课程
  getMyCourses: async () => {
    try {
      const response = await getMyCourses()
      return response.data || response
    } catch (error) {
      console.error('获取我的课程失败:', error)
      throw error
    }
  },

  // 获取特色技能分类列表
  getSkillCategories: async () => {
    try {
      const response = await getSkillCategories()
      return response.data || response
    } catch (error) {
      console.error('获取特色技能分类失败:', error)
      throw error
    }
  }
}

// 考试相关API
export const examAPI = {
  // 获取考试列表
  getExams: async (params = {}) => {
    try {
      const response = await getExamList(params)
      return response.data || response
    } catch (error) {
      console.error('获取考试列表失败:', error)
      throw error
    }
  },

  // 获取专业列表
  getMajors: async () => {
    try {
      const response = await getMajorList()
      return response.data || response
    } catch (error) {
      console.error('获取专业列表失败:', error)
      throw error
    }
  },

  // 获取考试详情
  getExamDetail: async (id) => {
    try {
      const response = await getExamDetail(id)
      return response.data || response
    } catch (error) {
      console.error('获取考试详情失败:', error)
      throw error
    }
  },

  // 报名考试
  registerExam: async (data) => {
    try {
      const response = await applyExam(data)
      return response.data || response
    } catch (error) {
      console.error('报名考试失败:', error)
      throw error
    }
  },

  // 获取我的报名
  getMyApplications: async () => {
    try {
      const response = await getMyExamApplications()
      return response.data || response
    } catch (error) {
      console.error('获取我的报名失败:', error)
      throw error
    }
  },

  // 获取报名详情
  getApplicationDetail: async (id) => {
    try {
      const response = await getExamApplicationDetail(id)
      return response.data || response
    } catch (error) {
      console.error('获取报名详情失败:', error)
      throw error
    }
  },

  // 下载准考证
  downloadTicket: async (params) => {
    try {
      const response = await downloadExamTicket(params)
      return response
    } catch (error) {
      console.error('下载准考证失败:', error)
      throw error
    }
  },

  // 查询准考证
  queryTicket: async (params) => {
    try {
      const response = await queryExamTicket(params)
      return response.data || response
    } catch (error) {
      console.error('查询准考证失败:', error)
      throw error
    }
  }
}

// 职位相关API
export const jobAPI = {
  // 获取职位列表
  getJobs: async (params = {}) => {
    try {
      const response = await getJobList(params)
      return response.data || response
    } catch (error) {
      console.error('获取职位列表失败:', error)
      throw error
    }
  },

  // 获取职位详情
  getJobDetail: async (id) => {
    try {
      const response = await getJobDetail(id)
      return response.data || response
    } catch (error) {
      console.error('获取职位详情失败:', error)
      throw error
    }
  },

  // 投递职位
  applyJob: async (data) => {
    try {
      const response = await applyJob(data)
      return response.data || response
    } catch (error) {
      console.error('投递职位失败:', error)
      throw error
    }
  },

  // 获取我的投递
  getMyApplications: async () => {
    try {
      const response = await getMyJobApplications()
      return response.data || response
    } catch (error) {
      console.error('获取我的投递失败:', error)
      throw error
    }
  }
}

// 人才相关API
export const talentAPI = {
  // 获取人才列表
  getTalents: async (params = {}) => {
    try {
      const response = await getTalentList(params)
      return response.data || response
    } catch (error) {
      console.error('获取人才列表失败:', error)
      throw error
    }
  },

  // 获取人才详情
  getTalentDetail: async (id) => {
    try {
      const response = await getTalentDetail(id)
      return response.data || response
    } catch (error) {
      console.error('获取人才详情失败:', error)
      throw error
    }
  },

  // 提交人才申请
  submitApplication: async (data) => {
    try {
      const response = await submitTalentApplication(data)
      return response.data || response
    } catch (error) {
      console.error('提交人才申请失败:', error)
      throw error
    }
  },

  // 获取我的人才档案
  getMyProfile: async () => {
    try {
      const response = await getMyTalentProfile()
      return response.data || response
    } catch (error) {
      console.error('获取我的人才档案失败:', error)
      throw error
    }
  },

  // 更新人才档案
  updateProfile: async (data) => {
    try {
      const response = await updateTalentProfile(data)
      return response.data || response
    } catch (error) {
      console.error('更新人才档案失败:', error)
      throw error
    }
  },

  // 获取人才分类列表
  getCategories: async () => {
    try {
      const response = await getTalentCategories()
      return response.data || response
    } catch (error) {
      console.error('获取人才分类失败:', error)
      throw error
    }
  }
}

// 订单相关API
export const orderAPI = {
  // 创建订单
  createOrder: async (data) => {
    try {
      const response = await createOrder(data)
      return response.data || response
    } catch (error) {
      console.error('创建订单失败:', error)
      throw error
    }
  }
}

// 支付相关API
export const paymentAPI = {
  // 查询支付状态
  getPaymentStatus: async (orderNo) => {
    try {
      const response = await getPaymentStatus(orderNo)
      return response.data || response
    } catch (error) {
      console.error('查询支付状态失败:', error)
      throw error
    }
  }
}

// 应用初始化API
export const appAPI = {
  // 初始化应用
  initApp: async (data) => {
    try {
      const response = await initApp(data)
      return response.data || response
    } catch (error) {
      console.error('初始化应用失败:', error)
      throw error
    }
  }
}

// 统计相关API（暂时保留，后续可以添加真实API）
export const statsAPI = {
  // 获取统计数据
  getStats: async () => {
    try {
      // 这里可以调用真实的统计API
      // 暂时返回默认数据
      return {
        totalCourses: 0,
        totalExams: 0,
        totalJobs: 0,
        totalTalents: 0
      }
    } catch (error) {
      console.error('获取统计数据失败:', error)
      throw error
    }
  }
}

// 分类相关API
export const typeAPI = {
  // 获取分类类型列表
  getTypeList: async (params = {}) => {
    try {
      const response = await getTypeList(params)
      return response.data || response
    } catch (error) {
      console.error('获取分类列表失败:', error)
      throw error
    }
  }
}

// 消息相关API
export const messageAPI = {
  // 获取消息列表
  getMessages: async (params = {}) => {
    try {
      const response = await getMessages(params)
      return response.data || response
    } catch (error) {
      console.error('获取消息列表失败:', error)
      throw error
    }
  },

  // 标记消息已读
  markAsRead: async (id) => {
    try {
      const response = await markMessageRead(id)
      return response.data || response
    } catch (error) {
      console.error('标记消息已读失败:', error)
      throw error
    }
  },

  // 全部标记已读
  markAllAsRead: async () => {
    try {
      const response = await markAllMessagesRead()
      return response.data || response
    } catch (error) {
      console.error('全部标记已读失败:', error)
      throw error
    }
  }
}

// 帮助中心相关API
export const helpAPI = {
  // 获取帮助中心类型列表
  getTypes: async () => {
    try {
      const response = await getHelpTypes()
      return response.data || response
    } catch (error) {
      console.error('获取帮助中心类型失败:', error)
      throw error
    }
  },

  // 获取帮助中心分类列表
  getCategories: async () => {
    try {
      const response = await getHelpCategories()
      return response.data || response
    } catch (error) {
      console.error('获取帮助中心分类失败:', error)
      throw error
    }
  },

  // 获取帮助中心内容详情
  getDetail: async (type) => {
    try {
      const response = await getHelpDetail(type)
      return response.data || response
    } catch (error) {
      console.error('获取帮助中心详情失败:', error)
      throw error
    }
  }
}

// 首页Banner相关API
export const bannerAPI = {
  // 获取Banner列表
  getBanners: async () => {
    try {
      const response = await getBannerList()
      return response.data || response
    } catch (error) {
      console.error('获取Banner列表失败:', error)
      throw error
    }
  }
}

// 公告相关API
export const noticeAPI = {
  // 获取公告列表
  getNotices: async (params = {}) => {
    try {
      const response = await getNoticeList(params)
      return response.data || response
    } catch (error) {
      console.error('获取公告列表失败:', error)
      throw error
    }
  },

  // 获取公告详情
  getNoticeDetail: async (id) => {
    try {
      const response = await getNoticeDetail(id)
      return response.data || response
    } catch (error) {
      console.error('获取公告详情失败:', error)
      throw error
    }
  }
}

// 题库相关API
export const quizAPI = {
  // 获取题库列表（支持分页和分类）
  getQuizzes: async (params = {}) => {
    try {
      const response = await getQuizList(params)
      return response.data || response
    } catch (error) {
      console.error('获取题库列表失败:', error)
      throw error
    }
  },

  // 获取题库详情
  getQuizDetail: async (id) => {
    try {
      const response = await getQuizDetail(id)
      return response.data || response
    } catch (error) {
      console.error('获取题库详情失败:', error)
      throw error
    }
  },

  // 获取某专业下的试卷列表
  getPapers: async (majorId) => {
    try {
      const response = await getQuestionPapers({ major_id: majorId })
      return response.data || response
    } catch (error) {
      console.error('获取试卷列表失败:', error)
      throw error
    }
  },

  // 获取试卷下的题目列表（含选项）
  getQuestions: async (paperId) => {
    try {
      const response = await getQuestionList({ paper_id: paperId })
      return response.data || response
    } catch (error) {
      console.error('获取题目列表失败:', error)
      throw error
    }
  },

  // 提交答题记录与成绩统计
  submitAnswers: async (paperId, answers) => {
    try {
      const response = await submitQuestionAnswers({ paper_id: paperId, answers })
      return response.data || response
    } catch (error) {
      console.error('提交答题记录失败:', error)
      throw error
    }
  },

  // 提交试卷答题结果（做题/背题模式）
  submitPracticeResult: async (data) => {
    try {
      const response = await submitQuestionPaper(data)
      return response.data || response
    } catch (error) {
      console.error('提交试卷结果失败:', error)
      throw error
    }
  }
}

// 学情相关API
export const learningAPI = {
  // 获取学习概况
  getLearningOverview: async () => {
    try {
      // 暂时返回模拟数据
      return {
        total_courses: 5,
        completed_courses: 2,
        total_quizzes: 10,
        completed_quizzes: 6,
        total_learning_hours: 45.5,
        average_accuracy: 78,
        recent_activities: [
          {
            id: 1,
            type: 'course',
            title: '中医基础理论',
            action: '学习了第3章',
            time: '2小时前'
          },
          {
            id: 2,
            type: 'quiz',
            title: '中医诊断学题库',
            action: '完成练习，正确率85%',
            time: '5小时前'
          },
          {
            id: 3,
            type: 'course',
            title: '中药学',
            action: '学习了第5章',
            time: '1天前'
          }
        ]
      }
    } catch (error) {
      console.error('获取学习概况失败:', error)
      throw error
    }
  },

  // 获取课程学习进度
  getCourseProgress: async (courseId) => {
    try {
      const response = await getCourseProgress(courseId)
      return response.data || response
    } catch (error) {
      console.error('获取课程学习进度失败:', error)
      throw error
    }
  },

  // 获取题库练习记录
  getQuizRecords: async (params = {}) => {
    try {
      // 暂时返回模拟数据
      return {
        data: [
          {
            id: 1,
            quiz_id: 1,
            quiz_name: '中医基础理论题库',
            score: 42,
            total_questions: 50,
            accuracy: 84,
            total_time: 25,
            completed_at: '2026-04-11T15:30:00Z',
            status: 'completed'
          },
          {
            id: 2,
            quiz_id: 2,
            quiz_name: '中药学题库',
            score: 68,
            total_questions: 80,
            accuracy: 85,
            total_time: 40,
            completed_at: '2026-04-10T10:20:00Z',
            status: 'completed'
          },
          {
            id: 3,
            quiz_id: 3,
            quiz_name: '方剂学题库',
            score: 45,
            total_questions: 60,
            accuracy: 75,
            total_time: 35,
            completed_at: '2026-04-09T14:15:00Z',
            status: 'completed'
          }
        ],
        total: 3,
        last_page: 1,
        current_page: 1,
        per_page: 10
      }
    } catch (error) {
      console.error('获取题库练习记录失败:', error)
      throw error
    }
  },

  // 同步与上报课时学习进度
  saveLearningProgress: async (lessonId, currentTime) => {
    try {
      const response = await saveLearningProgress({ lesson_id: lessonId, current_time: currentTime })
      return response.data || response
    } catch (error) {
      console.error('保存学习进度失败:', error)
      throw error
    }
  },

  // 更新学习进度
  updateLearningProgress: async (data) => {
    try {
      // 暂时返回模拟数据
      return {
        success: true,
        message: '学习进度更新成功',
        data: {
          id: Date.now(),
          ...data,
          updated_at: new Date().toISOString()
        }
      }
    } catch (error) {
      console.error('更新学习进度失败:', error)
      throw error
    }
  },

  // 获取学习建议
  getLearningRecommendations: async () => {
    try {
      // 暂时返回模拟数据
      return {
        recommendations: [
          {
            id: 1,
            type: 'course',
            title: '中医诊断学',
            reason: '基于您对中医基础理论的学习，建议您学习中医诊断学以加深理解',
            priority: 'high'
          },
          {
            id: 2,
            type: 'quiz',
            title: '中医基础理论题库',
            reason: '您上次练习的正确率为75%，建议再次练习以巩固知识点',
            priority: 'medium'
          },
          {
            id: 3,
            type: 'course',
            title: '中药学进阶',
            reason: '您已经完成了中药学基础课程，建议学习进阶内容',
            priority: 'medium'
          }
        ]
      }
    } catch (error) {
      console.error('获取学习建议失败:', error)
      throw error
    }
  }
}
